export default __webpack_public_path__ + "static/media/14.67a5b600.png";